import React from 'react';
import { useListCustomersQuery, useReadCustomerQuery } from '@/store/api/customer/customer.api';
import type { TypeApiError } from '@/types/api/types.api';
import type { TypeCustomer } from '@/types/customer/types.customer';

const EMPTY: TypeCustomer[] = [];

export const useCustomers = (): TypeCustomer[] => {
    const { data } = useListCustomersQuery();
    return data ?? EMPTY;
};

export const useCustomer = (customerId: string | null): TypeCustomer | null => {
    const customers = useCustomers();
    return React.useMemo(
        () => customers.find((customer) => customer.id === customerId) ?? null,
        [customers, customerId],
    );
};

export const useCustomersState = () => {
    const { data, isLoading, isFetching, isError, error, refetch } = useListCustomersQuery();
    return { customers: data ?? EMPTY, isLoading, isFetching, isError, error, refetch };
};

export const useCustomerDetail = (customerId: string | null) => {
    const { data, isLoading, isFetching, isError, error, refetch } = useReadCustomerQuery(customerId as string, { skip: !customerId });
    const notFound = isError && (error as TypeApiError | undefined)?.status === 404;

    return {
        customer: data ?? null,
        isLoading,
        isFetching,
        missing: notFound || !customerId,
        isError: isError && !notFound,
        refetch,
    };
};
